import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "ms-2" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "scrollListContainer" }
const _hoisted_6 = { class: "scrollBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_answers_viewer = _resolveComponent("form-answers-viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("b", null, "Progetto:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.cart.project), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("b", null, "Nazione:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.cart.country), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Articoli",
          text: "Articoli"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.offers, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "scrollListItem",
              key: item.offer.identifier
            }, _toDisplayString(item.offer.name) + " x " + _toDisplayString(item.quantity), 1))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_form_answers_viewer, {
      answers: _ctx.cart.formAnswers
    }, null, 8, ["answers"])
  ]))
}